import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
import Layout from "@/layout/Layout.vue";
import Account from "@/views/account/Account.vue";

// const routes = [
//   {
//     path: "/",
//     name: "Layout",
//     component: Layout,
//     redirect: "/workbench",
//     children: [
//       {
//         path: "/workbench",
//         name: "Workbench",
//         meta: {
//           title: "工作台",
//           icon: "&#xe801;",
//         },
//         component: () => import("@/views/workbench/Workbench.vue"),
//       },
//       {
//         path: "/order",
//         name: "Order",
//         meta: {
//           title: "订单",
//           icon: "&#xe6ef;",
//         },
//         component: () => import("@/views/order/Order.vue"),
//         redirect: "/order/index",
//         children: [
//           {
//             path: "/order/index",
//             name: "OrderIndex",
//             meta: {
//               title: "销售单",
//             },
//             component: () => import("@/views/order/OrderIndex.vue"),
//           },
//           {
//             path: "/order/purchase",
//             name: "Purchase",
//             meta: {
//               title: "采购单",
//             },
//             component: () => import("@/views/order/OrderPurchase.vue"),
//           },
//           {
//             path: "/order/return",
//             name: "Return",
//             meta: {
//               title: "退货单",
//             },
//             component: () => import("@/views/order/OrderReturn.vue"),
//           },
//         ],
//       },
//       {
//         path: "/wiki",
//         name: "Wiki",
//         meta: {
//           title: "Wiki",
//           icon: "&#xe6ef;",
//         },
//         component: () => import("@/views/wiki/Wiki.vue"),
//         redirect: "/wiki/index",
//         children: [
//           {
//             path: "/wiki/index",
//             name: "WikiIndex",
//             meta: {
//               title: "销售单",
//             },
//             component: () => import("@/views/wiki/WikiIndex.vue"),
//           },
//         ],
//       },
//       {
//         path: "/system",
//         name: "System",
//         meta: {
//           title: "系统",
//           icon: "&#xe801;",
//         },
//         component: () => import("@/views/System.vue"),
//         redirect: "/system/user",
//         children: [
//           {
//             path: "/system/user",
//             name: "User",
//             meta: {
//               title: "用户列表",
//             },
//             component: () => import("@/views/system/privilege/User.vue"),
//           },
//           {
//             path: "/system/role",
//             name: "Role",
//             meta: {
//               title: "角色管理",
//             },
//             component: () => import("@/views/system/privilege/Role.vue"),
//           },
//           {
//             path: "/system/permission",
//             name: "Permission",
//             meta: {
//               title: "权限管理",
//             },
//             component: () => import("@/views/system/privilege/Permission.vue"),
//           },
//           {
//             path: "/system/spa",
//             name: "Spa",
//             meta: {
//               title: "单页管理",
//             },
//             component: () => import("@/views/system/privilege/Spa.vue"),
//           },
//           {
//             path: "/system/exceptionlog",
//             name: "ExceptionLog",
//             meta: {
//               title: "请求日志",
//             },
//             component: () => import("@/views/system/monitor/ExceptionLog.vue"),
//           },
//           {
//             path: "/system/menu",
//             name: "Menu",
//             meta: {
//               title: "菜单列表",
//             },
//             component: () => import("@/views/system/privilege/Menu.vue"),
//           },
//           {
//             path: "/system/personcenter",
//             name: "PersonCenter",
//             meta: {
//               title: "个人中心",
//             },
//             component: () => import("@/views/system/settings/PersonCenter.vue"),
//           },
//           {
//             path: "/system/copyright",
//             name: "Copyright",
//             meta: {
//               title: "版权设置",
//             },
//             component: () => import("@/views/system/settings/Copyright.vue"),
//           },
//           {
//             path: "/system/email",
//             name: "Email",
//             meta: {
//               title: "邮件配置",
//             },
//             component: () => import("@/views/system/settings/Email.vue"),
//           },
//           {
//             path: "/system/timer",
//             name: "Timer",
//             meta: {
//               title: "定时任务",
//             },
//             component: () => import("@/views/system/task/Timer.vue"),
//           },
//         ],
//       },
//     ],
//   },
//   // {
//   //   path: "/login",
//   //   name: "AdminLogin",
//   //   meta: {
//   //     title: "登录",
//   //   },
//   //   component: AdminLogin,
//   // },
//   {
//     path: "/account",
//     name: "Account",
//     meta: {
//       title: "账号",
//     },
//     component: Account,
//     redirect: "/account/login",
//     children: [
//       {
//         path: "/account/login",
//         name: "AdminLogin",
//         meta: {
//           title: "登录",
//         },
//         component: () => import("@/views/account/Login.vue"),
//       },
//       {
//         path: "/account/register",
//         name: "Register",
//         meta: {
//           title: "注册",
//         },
//         component: () => import("@/views/account/Register.vue"),
//       },
//       {
//         path: "/account/forget",
//         name: "Forget",
//         meta: {
//           title: "忘记密码",
//         },
//         component: () => import("@/views/account/Forget.vue"),
//       },
//     ],
//   },
//   {
//     path: "/error",
//     name: "Error",
//     meta: {
//       title: "404",
//     },
//     component: () => import("@/views/Error.vue"),
//   },
//   {
//     path: "/:pathMatch(.*)",
//     redirect: "/error",
//   },
// ];
// 静态路由
export const staticRoutes = [
  {
    path: "/account",
    name: "Account",
    meta: {
      title: "账号",
    },
    component: () => import("@/views/account/Account.vue"),
    redirect: "/account/login",
    children: [
      {
        path: "/account/login",
        name: "Login",
        meta: {
          title: "登录",
        },
        component: () => import("@/views/account/Login.vue"),
      },
      {
        path: "/account/register",
        name: "Register",
        meta: {
          title: "注册",
        },
        component: () => import("@/views/account/Register.vue"),
      },
      {
        path: "/account/forget",
        name: "Forget",
        meta: {
          title: "忘记密码",
        },
        component: () => import("@/views/account/Forget.vue"),
      },
    ],
  },
  // {
  //   path: "/perview",
  //   name: "Perview",
  //   meta: {
  //     title: "Perview",
  //   },
  //   component: () => import("@/views/Yd.vue"),
  // },
  {
    path: "/500",
    name: "500",
    meta: {
      title: "500",
    },
    component: () => import("@/views/error/500.vue"),
  },
];

// 动态路由
export const dynamicRoutes = [
  {
    path: "/",
    name: "/",
    component: () => import("@/layout/Layout.vue"),
    redirect: "/workbench",
    children: [],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  // routes: [...staticRoutes, ...dynamicRoutes],
  routes: staticRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 防止路由无限循环
let routeFlag = false;

// 路由导航守卫
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("TOKEN");

  // 定义放行的路由
  const noPermissionPaths = [
    "/account/login",
    "/account/register",
    "/account/forget",
    "/account/logout",
  ];
  // 如果没有token，并且不在白名单中，就跳转到登录界面
  // if (!token && !noPermissionPaths.includes(to.path)) {
  //   routeFlag = false
  //   next("/account/login");
  // } else {
  //   if (routeFlag) return next()
  //   // 权限控制
  //   routeFlag = true
  //   // 请求路由数据
  //   await store.dispatch('generateRoutes')
  //   // 动态挂载路由
  //   router.addRoute(dynamicRoutes[0])
  //   // 添加 404 路由
  //   router.addRoute(
  //     {
  //       path: "/:pathMatch(.*)",
  //       name: "404",
  //       component: () => import("@/views/Error.vue"),
  //       meta: {
  //         title: "404",
  //       },
  //     }
  //   )
  //   next({
  //     ...to,//重新进入
  //     replace: true//不保存本次进入页面的路由历史记录
  //   })
  // }

  // 第二种
  if (!token && !noPermissionPaths.includes(to.path)) {
    next("/account/login");
  } else {
    if (token && token !== "undefined" && store.state.routes.length === 0) {
      await store.dispatch("generateRoutes");
      router.addRoute(dynamicRoutes[0]);
      next(to.fullPath);
      // next({ ...to, replace: true })
    } else {
      next();
      // next(`/account/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
    }
    // next()
  }
  // 第二种
});

export default router;
